export const LIKE = 'LIKE';
export const EQ = '=';
export const NE = '!=';
export const GT = '>';
export const GE = '>=';
export const LT = '<';
export const LE = '<=';
export const FT = '>= <=';
